export * from './campaign.service';
import { CampaignService } from './campaign.service';
export * from './codeBase.service';
import { CodeBaseService } from './codeBase.service';
export * from './pageConfig.service';
import { PageConfigService } from './pageConfig.service';
export * from './pages.service';
import { PagesService } from './pages.service';
export * from './simulator.service';
import { SimulatorService } from './simulator.service';
export const APIS = [CampaignService, CodeBaseService, PageConfigService, PagesService, SimulatorService];
